import React from 'react';
import { FullViewProps } from '../types';
import { Film } from './Film';
import { useVideoPlayerActionBiLogger } from '../hooks/useVideoPlayerActionBiLogger';

/** Wrapped version of Film that is used for full film deviations */
export const FilmDeviation: React.FC<FullViewProps> = ({ deviation, ...rest }) => {
  const onPlaybackAction = useVideoPlayerActionBiLogger(deviation);
  return <Film source={deviation} onPlaybackAction={onPlaybackAction} {...rest} />;
};
FilmDeviation.displayName = 'FilmDeviation';

export default FilmDeviation;
